<template>
  <FallbackView content-gap="48px" icon-text-gap="50px" text-gap="32px">
    <template #icon>
      <icon
        data="@icon/lock.svg"
        width="127px"
        height="180px"
        color="#F346F7 #A3A3A3 #A3A3A3"
      />
    </template>

    <template #content>
      <div class="headline">
        <span class="text-[64px] uppercase font-semibold text-[var(--tag-info-pink)]">
          Access Denied!
        </span>
      </div>
      <div class="description">
        <span class="text-[36px] text-[var(--text-color)]">
          You do not have enough rights to access GenTwo Pro.
        </span>
      </div>
    </template>
  </FallbackView>
</template>

<script setup>
import FallbackView from '@/components/elements/FallbackView.vue';
</script>

